import { render, staticRenderFns } from "./withdraw-currency-filter.vue?vue&type=template&id=689a581e&scoped=true&"
import script from "./withdraw-currency-filter.vue?vue&type=script&lang=js&"
export * from "./withdraw-currency-filter.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-currency-filter.vue?vue&type=style&index=0&id=689a581e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a581e",
  null
  
)

/* custom blocks */
import block0 from "../locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fmine%2Fcomponents%2Fwithdraw-currency-filter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports